<ion-header>
  <ion-toolbar>
    <ion-title>{{"boulder-filter-component.filter-and-sort" | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" fill="clear">
        <ion-icon name="close" slot="start"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<loader [timeoutInSeconds]="20" *ngIf="!allBoulders"></loader>
<ion-content *ngIf="allBoulders">
  <ion-list>
    <ion-item>
      <ion-select (ionChange)="computeNumberOfBoulders()" [(ngModel)]="ascentFilter"
                  [label]="'boulder-filter-component.ascent' | translate"
                  [placeholder]="'boulder-filter-component.ascent' | translate"
                  [ngClass]="ascentFilter!=='all'?'active-filter':''">
        <ion-select-option [value]="'all'">{{"boulder-filter-component.whatever" | translate}}</ion-select-option>
        <ion-select-option
          [value]="'only-projects'">{{"boulder-filter-component.only-projects" | translate}}</ion-select-option>
        <ion-select-option *ngIf="!guestService.isGuest()"
                           [value]="'only-sent-by-user'">{{"boulder-filter-component.already-ticked" | translate}}</ion-select-option>
        <ion-select-option *ngIf="!guestService.isGuest()"
                           [value]="'only-not-sent-by-user'">{{"boulder-filter-component.not-yet-ticked" | translate}}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-select (ionChange)="computeNumberOfBoulders()" [label]='"boulder-filter-component.choose-wall" | translate'
                  [placeholder]="walls?.length===0?('boulder-filter-component.walls' | translate):walls?.length===1?walls[0]:walls[0]+',...'"
                  multiple="true" [(ngModel)]="walls" [ngClass]="walls?.length>0?'active-filter':''">
        <ion-select-option *ngFor="let wall of availableWalls"
                           [value]="wall.wallName">{{wall.wallName}}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-select [(ngModel)]="sortBy" class="sort-item" [label]='"boulder-filter-component.sorting" | translate'
                  placeholder='{{"boulder-filter-component.choose-sorting" | translate}}'>
        <ion-select-option value="date">{{"boulder-filter-component.newest-first" | translate}}</ion-select-option>
        <ion-select-option
          value="rating-descending">{{"boulder-filter-component.popular-first" | translate}}</ion-select-option>
        <ion-select-option
          value="grade-descending">{{"boulder-filter-component.hardest-first" | translate}}</ion-select-option>
        <ion-select-option
          value="grade-ascending">{{"boulder-filter-component.easiest-first" | translate}}</ion-select-option>
        <ion-select-option
          value="num-ascents-descending">{{"boulder-filter-component.most-ascents-first" | translate}}</ion-select-option>
        <ion-select-option
          value="num-ascents-ascending">{{"boulder-filter-component.least-ascents-first" | translate}}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-toggle slot="end" [(ngModel)]="onlyCampusBoulders" data-cy="only-campus-boulders-toggle"
                  (ionChange)="toggleOnlyCampusButton($event)">{{"boulder-filter-component.only-campus-boulders" | translate}}</ion-toggle>
    </ion-item>
    <ion-item>
      <ion-toggle slot="end" [(ngModel)]="noCampusBoulders" data-cy="no-campus-boulders-toggle"
                  (ionChange)="toggleNoCampusButton($event)">{{"boulder-filter-component.no-campus-boulders" | translate}}</ion-toggle>
    </ion-item>
    <ion-list-header>
      <ion-label>{{"boulder-filter-component.grade" | translate}}</ion-label>
    </ion-list-header>
    <ion-item>
      <ion-range aria-label="grade rangegit" (ionInput)="computeNumberOfBoulders($event)" (ionChange)="computeNumberOfBoulders($event)" [(ngModel)]="gradeRange" dualKnobs="true" [ticks]="true" [snaps]="true" [min]="0" [max]="maxGrade" color="secondary">
        <span [ngClass]="gradeRange.lower>0?'active-filter':''"
                   slot="start">{{gradeRange.lower | boulderGrade}}</span>
        <span [ngClass]="gradeRange.upper<maxGrade?'active-filter':''"
                   slot="end">{{gradeRange.upper | boulderGrade}}</span>
      </ion-range>
    </ion-item>
    <ion-item class="num-boulders">
      <ion-label slot="end" *ngIf="numberOfBouldersPassingFilter !== null">
        <span
          [ngClass]="numberOfBouldersPassingFilter<allBoulders?.length?'active-filter':''">{{numberOfBouldersPassingFilter}}</span>
        / {{allBoulders?.length}} {{"boulder-filter-component.boulder" | translate}}
      </ion-label>
      <ion-label *ngIf="!numberOfBouldersPassingFilter === null">
        <ion-spinner></ion-spinner>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-button slot="start" color="secondary" fill="clear" size="small" (click)="reset()">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>
        {{"boulder-filter-component.reset" | translate}}
      </ion-button>
      <ion-button slot="end" data-cy="apply-button" size="medium" (click)="apply()">
        <ion-icon slot="start" name="checkmark-outline"></ion-icon>
        {{"boulder-filter-component.apply" | translate}}
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
